// Single source of truth for official brand assets. Replace files in /public/brand to update the logo everywhere.
export const BRAND = {
  name: "BalkanPuls.de",
  slogan: "NAŠI LJUDI. NAŠE TEME. NJEMAČKA.",
  email: "info@balkanpuls.de",
  // Official wordmark; logo-trim* only removes empty transparent canvas around the unchanged artwork.
  logo: "/brand/logo-trim-800.png",
  logoSrcSet: "/brand/logo-trim-400.png 400w, /brand/logo-trim-800.png 800w, /brand/logo-trim.png 1866w",
  logoOriginal: "/brand/balkanpuls-logo.png",
  logoRatio: 1866 / 472,
  icon: "/brand/balkanpuls-icon.png",
  iconSmall: "/brand/icon-192.png",
  ogImage: "/brand/og-default.jpg",
};

export const STATUS_LABELS = {
  draft: "Nacrt", in_review: "Na pregledu", needs_revision: "Potrebna dorada", fact_check: "Provjera činjenica",
  approved: "Odobreno", scheduled: "Zakazano", published: "Objavljeno", rejected: "Odbijeno",
  unpublished: "Povučeno", archived: "Arhivirano",
};

export const ARTICLE_TYPES = {
  vijest: "Vijest", izvjestaj: "Izvještaj", analiza: "Analiza", vodic: "Praktični vodič", intervju: "Intervju",
  komentar: "Komentar / Mišljenje", saopcenje: "Saopćenje", servisna: "Servisna informacija", sponzorisano: "Sponzorisani sadržaj",
};

export const INFO_CHECK = {
  not_checked: { label: "Nije provjereno", tone: "bg-slate-200 text-slate-800 dark:bg-slate-700 dark:text-slate-100" },
  verified: { label: "Provjereno", tone: "bg-emerald-100 text-emerald-900 dark:bg-emerald-900/50 dark:text-emerald-100" },
  partially_verified: { label: "Djelimično provjereno", tone: "bg-amber-100 text-amber-900 dark:bg-amber-900/50 dark:text-amber-100" },
  misleading: { label: "Obmanjujuće", tone: "bg-orange-100 text-orange-900 dark:bg-orange-900/50 dark:text-orange-100" },
  false: { label: "Netačno", tone: "bg-red-100 text-red-900 dark:bg-red-900/50 dark:text-red-100" },
};
